/* eslint-disable eqeqeq */
import React, { useState } from "react";
import CustomTooltip from "../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faDownload,
  // faEdit,
  faEye,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import PreviewInvoice from "./PreviewInvoice";
import { toast } from "../../components/ui/use-toast";
import axios from "axios";
import { API, get } from "../../config";

const InvoicingActionButton = ({
  id,
  setInvoicingId,
  toggleShowDelete,
  toggleShowApprove,
  used,
  status,
  reconciled,
  setEdit,
  item,
  setEditItem,
  toggleShowAddEditInvoicing,
  setLoading,
  trustId,
}) => {
  const [showView, setShowView] = useState(false);

  const toggleShowModal = () => {
    setShowView(!showView);
  };

  const downloadLetter = async () => {
    try {
      setLoading(true);
      const { data } = await get(
        `${API.INVOICING_DOWNLOAD}/${id}?trust_id=${trustId ? trustId : ""}`
      );
      let path = data?.data;
      if (path) {
        const response = await axios.get(`${path}`, {
          responseType: "blob",
        });
        const fileData = response.data;
        const url = window.URL.createObjectURL(new Blob([fileData]));
        var a = document.createElement("a");
        a.href = url;
        var file = path.split("/");
        a.setAttribute("download", file[file.length - 1] || "new_aba.aba");
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        toast.error("File does not exist.");
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      // const errors = e.response?.data?.errors;
      // Object.keys(errors).forEach((key) => {
      //   toast.error(errors[key][0]);
      // });
    }
  };

  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        <CustomTooltip message={"View"}>
          <span>
            <FontAwesomeIcon
              onClick={toggleShowModal}
              icon={faEye}
              size="1x"
              data-toggle="modal"
              data-target="#clientDetail"
            />
          </span>
        </CustomTooltip>
        {item?.file && (
          <>
            <span>/</span>
            <CustomTooltip message={"Download"}>
              <span>
                <FontAwesomeIcon
                  icon={faDownload}
                  size="1x"
                  onClick={() => {
                    downloadLetter(item?.file);
                  }}
                />
              </span>
            </CustomTooltip>
          </>
        )}
        {/* {status == 0 && (
          <>
            <span>/</span>
            <CustomTooltip message={"Edit"}>
              <span>
                <FontAwesomeIcon
                  icon={faEdit}
                  size="1x"
                  onClick={() => {
                    setInvoicingId(id);
                    setEdit(true);
                    setEditItem(item);
                    toggleShowAddEditInvoicing();
                  }}
                />
              </span>
            </CustomTooltip>
          </>
        )} */}
        {reconciled ? (
          <></>
        ) : (
          <>
            <span>/</span>
            <CustomTooltip message={"Delete"}>
              <span>
                <FontAwesomeIcon
                  icon={faTrash}
                  size="1x"
                  onClick={() => {
                    setInvoicingId(id);
                    toggleShowDelete();
                  }}
                />
              </span>
            </CustomTooltip>
          </>
        )}
        {status == 0 && (
          <>
            <span>/</span>
            <CustomTooltip message={"Approve"}>
              <span>
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  size="1x"
                  onClick={() => {
                    setInvoicingId(id);
                    toggleShowApprove();
                  }}
                />
              </span>
            </CustomTooltip>
          </>
        )}
      </span>
      {showView && (
        <PreviewInvoice
          showView={showView}
          setShowView={setShowView}
          data={item}
        />
      )}
    </>
  );
};

export default InvoicingActionButton;
